"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var CustomCheckBox = (function (_super) {
    __extends(CustomCheckBox, _super);
    function CustomCheckBox(props) {
        return _super.call(this, props) || this;
    }
    CustomCheckBox.prototype.render = function () {
        var _a = this.props, id = _a.id, onChange = _a.onChange, checked = _a.checked, disabled = _a.disabled;
        return (react_1.default.createElement("input", { id: "" + id, type: "checkbox", checked: checked, disabled: disabled, onChange: function (e) {
                onChange(e, id);
            } }));
    };
    return CustomCheckBox;
}(react_1.Component));
exports.CustomCheckBox = CustomCheckBox;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ3VzdG9tQ2hlY2tCb3guanMiLCJzb3VyY2VSb290IjoiLi8iLCJzb3VyY2VzIjpbInBkZi9jb21wb25lbnRzL0N1c3RvbUNoZWNrQm94LnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7O0FBQUEsNkNBQXNDO0FBU3RDO0lBQW9DLGtDQUFvQjtJQUNwRCx3QkFBWSxLQUFLO2VBQ2Isa0JBQU0sS0FBSyxDQUFDO0lBQ2hCLENBQUM7SUFDTSwrQkFBTSxHQUFiO1FBQ1UsSUFBQSxlQUE4QyxFQUE3QyxVQUFFLEVBQUUsc0JBQVEsRUFBRSxvQkFBTyxFQUFFLHNCQUFzQixDQUFBO1FBQ3BELE9BQU8sQ0FDSCx5Q0FDSSxFQUFFLEVBQUUsS0FBRyxFQUFJLEVBQ1gsSUFBSSxFQUFDLFVBQVUsRUFDZixPQUFPLEVBQUUsT0FBTyxFQUNoQixRQUFRLEVBQUUsUUFBUSxFQUNsQixRQUFRLEVBQUUsVUFBQyxDQUFDO2dCQUNSLFFBQVEsQ0FBQyxDQUFDLEVBQUUsRUFBRSxDQUFDLENBQUE7WUFDbkIsQ0FBQyxHQUNILENBQ0wsQ0FBQTtJQUNMLENBQUM7SUFDTCxxQkFBQztBQUFELENBQUMsQUFsQkQsQ0FBb0MsaUJBQVMsR0FrQjVDO0FBbEJZLHdDQUFjIn0=